export const nsformfile = {
  common: 'libraries.formfile.common'
};